<template>
    <div>
        <h1>Választható Kiegészítő Fedezetek</h1>
        <div class="row p-3 mb-5">
            <div class="col-12 mb-3" v-for="(accesory, key) in accesoryList.showable" :key="key">
                <Accesory :accesory="accesory" :aKey="key" :selectable="true" />
            </div>
        </div>
    </div>
</template>

<script>
    import { mapFields } from 'vuex-map-fields'
    import Accesory from './components/Accesory'

    export default {
        components: {
            Accesory,
        },
        computed: {
            ...mapFields([
                'generalInfo.contractFor',
                'generalInfo.propertyInhabitated',
                'insuranceProperty.chosenInsurancePrice',
                'insurancePersonalGoods.calculatedInsurancePrice',
                'insurancePersonalGoods.acceptCalculatedInsurance',
                'insurancePersonalGoods.allGoodsPrice',
                'chooseableAccesories.valuablesAboveInputs',
            ]),
            ...mapFields({
                sideBuildings: 'insuranceSideBuildings.list',
                accesoriesList: 'chooseableAccesories.selectableList',
            }),
            accesoryList: function() {
                let showable = {}
                let notShowable = {}

                Object.entries(this.accesoriesList).forEach(accesory => {
                    if(accesory[1]?.showable?.includes(this.contractFor)) {
                        showable[accesory[0]] = accesory[1]
                    } else {
                        notShowable[accesory[0]] = accesory[1]
                    }

                    if(accesory[1]?.onlyLiving === true && !this.propertyInhabitated) {
                        if(accesory[0] in showable) {
                            delete showable[accesory[0]]
                            notShowable[accesory[0]] = accesory[1]
                        }
                    }
                })

                return {
                    showable: showable,
                    notShowable: notShowable
                }
            }
        },
    }
</script>